<script>
  // import input formatting functions
  import { formatCurrency, formatPercentage } from '../util';
  // calculate income required function
  import calculateIncomeRequired from './calculateIncomeRequired';
  // import calculator base components
  import CalculatorDisclaimer from '../CalculatorDisclaimer.svelte';
  import CalculatorFieldError from '../CalculatorFieldError.svelte';
  import CalculatorHeader from '../CalculatorHeader.svelte';
  import CalculatorSubmitInput from '../CalculatorSubmitInput';

  // company prop for passing to Disclaimer
  export let company;

  // fields
  let totalHomeLoanAmount = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let annualInterestRate = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let termOfTheLoan = {
    value: '30',
    error: false,
    errorMessage: 'Please select the Term of the Loan',
  };
  let annualRealEstateTaxes = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let monthlyDebtObligations = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };

  // result value
  let requiredSalary = 0;

  // has result been calculated?
  let calculated = false;

  // format percentage for annualInterestRate and update value
  function formatAnnualInterestRate() {
    // if no input entered, exit
    if (annualInterestRate.value === '') return;

    const formattedPercentage = formatPercentage(annualInterestRate.value);

    annualInterestRate.value = formattedPercentage;
  }

  // reactive statements to format input values when they change
  $: if (totalHomeLoanAmount.value !== '')
    totalHomeLoanAmount.value = formatCurrency(totalHomeLoanAmount.value);

  $: if (annualRealEstateTaxes.value !== '')
    annualRealEstateTaxes.value = formatCurrency(annualRealEstateTaxes.value);

  $: if (monthlyDebtObligations.value !== '')
    monthlyDebtObligations.value = formatCurrency(monthlyDebtObligations.value);

  // do required fields have a value?
  $: if (totalHomeLoanAmount.value !== '' && totalHomeLoanAmount.value !== '$0')
    totalHomeLoanAmount.error = false;

  $: if (
    annualInterestRate.value !== '' &&
    annualInterestRate.value !== '0.000%'
  )
    annualInterestRate.error = false;

  function setCalculatedAndCalculate() {
    if (totalHomeLoanAmount.value === '' || totalHomeLoanAmount.value === '$0')
      totalHomeLoanAmount.error = true;

    if (
      annualInterestRate.value === '' ||
      annualInterestRate.value === '0.000%'
    )
      annualInterestRate.error = true;

    if (
      totalHomeLoanAmount.value === '' ||
      totalHomeLoanAmount.value === '$0' ||
      annualInterestRate.value === '' ||
      annualInterestRate.value === '0.000%'
    )
      return;

    calculated = true;

    requiredSalary = calculateIncomeRequired(
      totalHomeLoanAmount.value,
      annualInterestRate.value,
      termOfTheLoan.value,
      annualRealEstateTaxes.value,
      monthlyDebtObligations.value
    );
  }
</script>

<div>
  <CalculatorHeader
    title="Income Required Calculator"
    subtitle="Calculate How Much You Need to Earn to Afford Your Dream Home" />
  <form on:submit|preventDefault={setCalculatedAndCalculate}>
    <div class="bg-gray-efftwo px-16 py-8">
      <div class="calculator-input-fields-wrapper">
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="totalHomeLoanAmount" class="block">
            Total Home Loan Amount
          </label>
          <input
            type="text"
            id="totalHomeLoanAmount"
            name="totalHomeLoanAmount"
            placeholder="$250,000"
            bind:value={totalHomeLoanAmount.value}
            class="mt-2" />
          <CalculatorFieldError field={totalHomeLoanAmount} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="annualInterestRate" class="block">
            Annual Interest Rate
          </label>
          <input
            type="text"
            id="annualInterestRate"
            name="annualInterestRate"
            placeholder="3.500%"
            on:blur={formatAnnualInterestRate}
            bind:value={annualInterestRate.value}
            class="mt-2" />
          <CalculatorFieldError field={annualInterestRate} />
        </div>
        <div class="calculator-field mb-12 lg:mb-0">
          <label for="termOfTheLoan" class="block">Term of the Loan</label>
          <select
            name="termOfTheLoan"
            id="termOfTheLoan"
            bind:value={termOfTheLoan.value}
            class="mt-2"
            required>
            <option value="30" selected>30 Years</option>
            <option value="25">25 Years</option>
            <option value="20">20 Years</option>
            <option value="15">15 Years</option>
            <option value="10">10 Years</option>
            <option value="5">5 Years</option>
          </select>
        </div>
        <div class="calculator-field mb-12 lg:mr-16 lg:mb-0">
          <label for="annualRealEstateTaxes" class="block">
            Annual Real Estate Taxes
          </label>
          <input
            type="text"
            id="annualRealEstateTaxes"
            name="annualRealEstateTaxes"
            placeholder="$500"
            bind:value={annualRealEstateTaxes.value}
            class="mt-2" />
        </div>
        <div class="calculator-field lg:mr-16">
          <label for="monthlyDebtObligations" class="block">
            Monthly Debt Obligations
          </label>
          <input
            type="text"
            id="monthlyDebtObligations"
            name="monthlyDebtObligations"
            placeholder="$250"
            bind:value={monthlyDebtObligations.value}
            class="mt-2" />
        </div>
      </div>
    </div>
    <CalculatorSubmitInput />
  </form>

  <div class="mt-10">
    {#if calculated}
      <div class="calculator-results-wrapper">
        <div class="px-8 pt-8 lg:px-16">
          <p class="calculator-result-title pl-0">Required Salary</p>
          <p class="calculator-result-result text-25">${requiredSalary}</p>
          <CalculatorDisclaimer {company} />
        </div>
      </div>
    {/if}
  </div>
</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/incomeRequiredCalculator/IncomeRequiredCalculator.svelte